import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { dispatchProductImpressions } from "@store/Services/AnalyticsService";
import setImpression from "@store/Store/Data/Analytics/Handlers/SetImpression";
import { getImpression } from "@store/Store/Data/Analytics/ImpressionsSelectors";
import { getCategory } from "@store/Store/Data/Categories/CategoriesSelectors";
import { getIsCategoryPage, getIsSearchPage } from "@store/Store/Pages/ProductList/ProductListSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";

addToEndOfChain(chain, async props => {
    if (props.result.products) {
        await waitFor(() => !!props.pricingLoaded);

        const state = props.getState();
        const currentPage = getCurrentPage(state);
        const isSearchPage = getIsSearchPage(state);
        const isCategoryPage = getIsCategoryPage(state);
        const category = getCategory(state);
        const currentCurency = state.context.session.currency?.currencyCode;

        const impressions = getImpression(state as StoreApplicationState);
        const currentPath = global?.location?.href || state.data.pages.location.pathname;
        const matchingImpressions = impressions?.filter(impression => {
            return impression.pageUrl === currentPath;
        });

        const impressionAlreadyOccured = !!matchingImpressions?.length;

        if (impressionAlreadyOccured) {
            return;
        }

        let products: ProductContextModel[] | undefined;

        const {
            pages: {
                productList: { productInfosByProductId },
            },
        } = state;

        if (props.result.products && productInfosByProductId) {
            products = props.result.products.map(product => {
                if (product) {
                    const productContext: ProductContextModel = {
                        product,
                        productInfo: productInfosByProductId[product.id] as ProductInfo,
                    };
                    return productContext;
                }
                return undefined;
            }) as ProductContextModel[];
        }

        if (products) {
            dispatchProductImpressions(
                products,
                currentCurency,
                currentPage,
                isCategoryPage,
                isSearchPage,
                category?.shortDescription || "",
            );
            props.dispatch(setImpression({ pageUrl: currentPath, impressions: props.result.products }));
        }
    }
});
